import {Link, Outlet, useLocation, useNavigate} from "react-router-dom";
import {Col, ConfigProvider, Row, theme} from "antd";
import React, {useEffect, useState} from "react";
import {
    DefaultFooter,
    ProConfigProvider,
    ProLayout,
    trTRIntl,
} from "@ant-design/pro-components";
import trTR from "antd/locale/tr_TR";
import {AuthProvider, useAuth} from "./AuthContext";

export default function Layout() {
    const location = useLocation();
    const [isDark, setIsDark] = useState(false);

    const navigate = useNavigate();
    const auth = useAuth();

    const [sidebarState, setSidebarState] = React.useState<boolean>(true);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

        setIsDark(mediaQuery.matches);

        const handler = (e: any) => setIsDark(e.matches);
        mediaQuery.addEventListener("change", handler);

        return () => mediaQuery.removeEventListener("change", handler);
    }, []);
    return (
        <ProConfigProvider dark={isDark} intl={trTRIntl} hashed={false}>
            <ConfigProvider locale={trTR}>
                <ProLayout
                    logo={"https://ouno.com.tr/assets/images/logo-dark.png"}
                    style={{
                        minHeight: "100vh",
                    }}

                    title={'Planogram'}
                    onCollapse={(collapsed) => {
                        console.log('coll', collapsed)
                        setSidebarState(collapsed);
                    }}
                    breakpoint={false}
                    defaultCollapsed={sidebarState}
                    collapsed={sidebarState}
                    hasSiderMenu={false}
                    fixSiderbar
                    location={{
                        pathname: location.pathname,
                    }}

                    footerRender={() => {
                        return (
                            <Row justify={'end'}>
                                <Col>
                                    <div style={{padding: 10, marginRight: 40, textAlign: 'center'}}>
                                        <a href={"https://yesilgezegen.com"} target={"_blank"} style={{
                                            color: '#707070',
                                            textDecoration: 'underline',
                                            filter: 'grayscale(100%)',
                                        }}>
                                            <img src="https://yesilgezegen.com/logo.png" style={{width: '100px'}}
                                                 alt=""/>
                                        </a>
                                    </div>

                                </Col>

                            </Row>


                        )
                    }}

                    menuItemRender={(item, dom) => (
                        <div>
                            <Link to={item.path || "/"}>{dom}</Link>
                        </div>
                    )}
                    menu={{
                        defaultOpenAll: false,
                        request: async () => {
                            return [
                                {
                                    key: "ordersItems",
                                    name: "Tüm Ürünler",
                                    path: "/orders/items",
                                },
                                {
                                    key: "logoDefaultConfig",
                                    name: "Ön Tanımlı Logo Ayarları",
                                    path: "/config",
                                },
                            ];
                        },
                    }}
                >
                    <Outlet/>

                </ProLayout>
            </ConfigProvider>
        </ProConfigProvider>
    );
}
